//
//
//
//
//
//
//
//
//
//
//
//

'use strict';

import { i18n } from '../../../ext/i18n'
import { CONTACT_FIELD_TYPES } from '../../constants'

export default {
   name: 'custom-input',
   props: ['contenteditable', 'text', 'idTextarea', 'typeField'],
   data() {
       return {
           locale: i18n.messages[i18n.locale],
           placeholder: false,
           focused: false,
       }
   },
   mounted() {        
       this.render()
       if(typeof this.text === 'undefined') {
           document.getElementById(this.idTextarea).innerText = ''
           this.showPlaceholder()       
       }
   },
   watch: {
       text() {
           this.checkText()
           this.showPlaceholder()
       },
       focused() {
           this.showPlaceholder()
       }
   },
   computed: {
       placeholderName() {
           switch(this.typeField) {
               case CONTACT_FIELD_TYPES.WORKPHONE:
               case CONTACT_FIELD_TYPES.HOMEPHONE:
               case CONTACT_FIELD_TYPES.MOBILEPHONE:
               case CONTACT_FIELD_TYPES.PHONE:
               case CONTACT_FIELD_TYPES.FAX:
                   return this.locale.loginPage.remote
               case CONTACT_FIELD_TYPES.WORKADDRESS:
               case CONTACT_FIELD_TYPES.HOMEADDRESS:
               case CONTACT_FIELD_TYPES.ADDRESS:
                   return this.locale.address
               case CONTACT_FIELD_TYPES.ICQ:
                   return this.locale.information.icq
               case CONTACT_FIELD_TYPES.SITE:
                   return this.locale.information.website
               case CONTACT_FIELD_TYPES.CHILDREN:
                   return this.locale.information.children
               case CONTACT_FIELD_TYPES.MAIL:
                   return this.locale.mail
           }
       },
   },
   methods: {
       update: function (event) {
           this.$emit('update:text', event.target.innerText);
       },
       render() {
           if(document.getElementById(this.idTextarea).innerText !== this.text) document.getElementById(this.idTextarea).innerText = this.text;
       },
       checkText() {
           if(this.text === this.locale['your-var']) {
               document.getElementById(this.idTextarea).innerText = ''
               this.focusInput()    
           } else this.render()
       },
       showPlaceholder() {
           if(!this.focused && document.getElementById(this.idTextarea).innerText === '') this.placeholder = true
           else this.placeholder = false
       },
       focusInput() {
           setTimeout(() => {
               let elem = document.getElementById(this.idTextarea)
               elem.focus();
           }, 0);
       },
       onFocus() {
           this.focused = true
       },
       onBlur() {
           this.focused = false
       }
   }    
}
